"use client";

import React, { CSSProperties } from "react";
import styles from "./gradient-background.module.scss";
import { useScroll } from "framer-motion";
import useScroller from "@/hooks/useScroller.hook";

type Props = {
  colorSize?: number | `${string}%`;
  imageOpacity?: number;
  imageSize?: number;
  containerStyle?: CSSProperties;
  blur?: boolean;
};

const GradientBackground = ({
  colorSize = "100%",
  imageOpacity = 1,
  imageSize = 400,
  containerStyle,
  blur = true,
}: Props) => {
  const scrollY = useScroller();

  return (
    <div className={styles.gradientContainer} style={containerStyle}>
      <div
        className={styles.gradient}
        style={{
          opacity: scrollY ? 200 / scrollY : 1,
          backgroundSize: colorSize,
        }}
      />
      <div
        className={styles.imageGradient}
        style={{
          opacity: imageOpacity,
          backgroundSize: imageSize,
          filter: blur ? "blur(2px)" : "none",
        }}
      />
    </div>
  );
};

export default GradientBackground;
